<div class="app-component" [style.backgroundImage]=" 'url(' + backgroundImageUrl + ')' ">
  <router-outlet></router-outlet>
</div>